import axios from '@/service/interceptor';
import settings from './settings';
import Config from './Config';

export function getMarkets() {
    const pm = new Promise((resolve) => {
        const timestamp = (new Date()).getTime();

        axios
            .get(`${settings.HOST_V2}/symbols?channel=${Config.channel}&timestamp=${timestamp}`)
            .then((res) => {
                resolve(res.data);
            });
    });
    return pm;
}

export function init() {
    const pm = new Promise((resolve) => {
        const timestamp = (new Date()).getTime();

        axios
            .get(`${settings.HOST_V2}/init?channel=${Config.channel}&timestamp=${timestamp}`)
            .then((res) => {
                resolve(res.data);
            });
    });
    return pm;
}
export function get24hKline() {
    const pm = new Promise((resolve) => {
        axios
            .get(`${settings.HOST_V2}/klines/day?channel=${Config.channel}`, { xDomain: true })
            .then((res) => {
                resolve(res.data);
            });
    });
    return pm;
}
export function getWebBannerList() {
    const pm = new Promise((resolve) => {
        const params = {
            cmd: 'webBannerList',
        };
        axios
            .post(`${settings.HOST_API}`, params)
            .then((res) => {
                resolve(res.data);
            });
    });
    return pm;
}
export function getMonies(marketsData) {
    return [...new Set(marketsData.map(item => item.quoteName))];
}
export function getStocks(marketsData) {
    return [...new Set(marketsData.map(item => item.quoteName))];
}

export function getAllMarketId(marketsData) {
    return marketsData.map(item => item.symbol);
}




// WEBPACK FOOTER //
// ./src/utils/market.js